export default "__VITE_ASSET__CC9RY5hy__"